<template>
  <!--
          作者：gmshop
          时间：2019-10-24
          描述：统计-会员统计-汇总
      -->
  <div class="d-a-c lh30 ww100 pt16">
    <div class="pt30 tc" style="width: 80px;">
      <p class="gray9">今日</p>
      <p class="gray9">昨日</p>
    </div>
    <div class="flex-1 tc">
      <p>累计点击</p>
      <p class="f20 fb gray3">{{dataModel.user.total.today}}</p>
      <p class="gray">{{dataModel.user.total.yesterday}}</p>
    </div>
    <div class="flex-1 tc">
      <p>新增点击数</p>
      <p class="f20 fb gray3">{{dataModel.user.add.today}}</p>
      <p class="gray">{{dataModel.user.add.yesterday}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    components:{
    },
    data() {
      return {
        /*是否正在加载*/
        loading: true,

      };
    },
    inject: ['dataModel'],
    created() {

    },
    methods: {


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/statistics/banner/part/Total.vue